module.exports = __webpack_public_path__ + "img/updates.b14085b9.svg";